import React from 'react';
import './Styles.css';
import { useNavigate } from 'react-router-dom';
import { formatMessage } from '../../Localization/formatMessage';
import Messages from '../../Localization/Messages';
import { ErrorMessages } from '../../Enums/ErrorMessages';
import { Ui16ArrowRight, Ui32Warning } from '@ids/react-icons';

const ErrorPage = ({ code, setError }) => {
  const defaultTitle = formatMessage(Messages.errorPage_title);
  const defaultDescription = '';
  const errorMessage = ErrorMessages.valueOf(code);
  const navigate = useNavigate();

  const title = errorMessage ? formatMessage(errorMessage.title) : defaultTitle;
  const description = errorMessage ? formatMessage(errorMessage.description) : defaultDescription;

  return (
    <div className="errorPage-container">
      <div className="errorPage-warningIcon">
        <Ui32Warning />
      </div>
      <h1>{title}</h1>
      <strong>
        {formatMessage(Messages.errorPage_error)} #{code}
      </strong>
      <br />
      <span>{description}</span>

      <ul className="errorPage-actions">
        <li
          onClick={() => {
            setError(null);
            window.location.reload(true);
          }}>
          <div
            className="clickable errorPage-action"
            onClick={() => {
              setError(null);
              window.location.reload(true);
            }}>
            <Ui16ArrowRight />
            {formatMessage(Messages.errorPage_tryToRefresh)}
          </div>
        </li>
        <li>
          <div
            className="clickable errorPage-action"
            onClick={() => {
              setError(null);
              navigate('/');
            }}>
            <Ui16ArrowRight />
            {formatMessage(Messages.common_goToSearch)}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ErrorPage;
